export enum DeliveryStatus {
  PENDING = 'pending',
  COMPLETE = 'complete',
  OVERDUE = 'overdue',
  DELETED = 'deleted'
}
